// extracted by mini-css-extract-plugin
export var alternate = "_12-h";
export var black = "_12-3";
export var blue = "_12-d";
export var blueLight = "_12-c";
export var brand = "_12-7";
export var error = "_12-9";
export var gray = "_12-6";
export var grayBlue = "_12-b";
export var iconWrapper = "_12-4";
export var indigo = "_12-e";
export var orange = "_12-g";
export var pink = "_12-f";
export var primary = "_12-0";
export var purple = "_12-8";
export var success = "_12-5";
export var warning = "_12-a";
export var white = "_12-1";
export var whiteSuccess = "_12-2";